export default {
  OPERACION_INDICADOR: (state, mutation) => { // ACTUALIZA ESTADO
    state.operacion = mutation.oper
    state.data = mutation.data
  },
  OPERACION_INDICADOR_MAP: (state, mutation) => { // ACTUALIZA ESTADO
    state.operacion = mutation.oper
    state.datMap = mutation.datMap
  },
}
